import React from "react";


const RadioChildGender = ({
    gender,
    handleChange,
    genderIndex,
    classNameBody,
    showTitle
                          }) => {
    return (
        <>
            <div className={`information-child__gender row ${classNameBody ? classNameBody : ''}`}>


                {showTitle ?  <div className="col-2 information-child__gender__selection">
                    <label>성별</label>
                </div> : ''}


                <div className={showTitle ? 'col-10 m-0 p-0' : 'col-12 text-center'}>
                    <label
                        className="input-selector information-child__margin-right-20"
                        onClick={(e)=>{
                            handleChange("M",genderIndex);
                        }}
                    >
                        <input
                            type="radio"
                            name={`gender${genderIndex}`}
                            checked={gender === 'M' ? true : false}
                            value={'M'}
                            onChange={()=>{}}
                        />
                        <div className="input-selector__content">
                            <img
                                className="input-selector__content__checked"
                                src="/images/icon_boy_w.svg"
                                alt=""
                            />
                            <img
                                className="input-selector__content__unchecked"
                                src="/images/icon_boy_g.svg"
                                alt=""
                            />
                            <span>남자</span>
                        </div>
                    </label>
                    <label
                        className="input-selector"
                        onClick={(e)=>{
                            handleChange("F",genderIndex);
                        }}
                    >
                        <input
                            type="radio"
                            name={`gender${genderIndex}`}
                            value={'F'}
                            checked={gender === 'F' ? true : false}
                            onChange={()=>{}}
                        />
                        <div className="input-selector__content">
                            <img
                                className="input-selector__content__checked"
                                src="/images/icon_girl_w.svg"
                                alt=""
                            />
                            <img
                                className="input-selector__content__unchecked"
                                src="/images/icon_girl_g.svg"
                                alt=""
                            />
                            <span>여자</span>
                        </div>
                    </label>
                </div>
            </div>
        </>

    )
}

RadioChildGender.defaultProps  = {
    genderIndex : 0,
    gender :  "M",
    classNameBody : '',
    showTitle : false
}

export default RadioChildGender;